import { ReactComponent as InfoIcon } from './info.svg';

export default InfoIcon;
